/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/IconPicker/IconDialog/Content/Item"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let iconBackgroundValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'background',
})
let iconIdValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'id',
})
let selectedBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'board_icon_id',
})
let aggregateData = fromHelpers.getBorder(iconBackgroundValueData, iconIdValueData, selectedBoardIconIdValueData)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let iconIdValueData1 = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'id',
})
  return (<React.Fragment
>
<button
  data-testid="Item.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--btlr-1-a5h7': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btrr-2-a5h7': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-3-a5h7': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbrr-4-a5h7': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-5-a5h7': aggregateData}}
 className={`views-block ${styles.Vertical}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 data="icon.id"
 iconId={iconIdValueData1}
/>
</button>
{children}
</React.Fragment>)
}